document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(
    ".article-content__table-of-content-links a"
  );
  const header = document.querySelector("header"); // Select the header element

  // Set the first link as active by default
  if (links.length > 0) {
    links[0].classList.add("active");
  }

  links.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default anchor behavior

      // Remove active state from all links
      links.forEach((l) => l.classList.remove("active"));
      link.classList.add("active"); // Add active state to the clicked link

      // Scroll to the target section with offset for the header and extra gap
      const targetId = link.getAttribute("href");
      const targetElement = document.querySelector(targetId);
      const headerHeight = header ? header.offsetHeight : 0;
      const offset = headerHeight + 10; // Add 10px gap

      if (targetElement) {
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});
